// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/shared/render

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function CustomerInfo(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'CustomerInfo',
      'aria-hidden': true,
      focusable: false,
      width: 44 * scale,
      height: 38 * scale,
      viewBox: '0 0 44 38',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement(
      'g',
      {stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd'},
      createElement('path', {
        d: 'M0 0h44v38H0V0zm1 1v36h42V1H1z',
        fillOpacity: '.4',
        fill: '#000',
      }),
      createElement('path', {
        fillOpacity: '.2',
        fill: '#D9D9D9',
        d: 'M1 1h42v36H1z',
      }),
      createElement('path', {
        d: 'M3 3v32h38V3H3zm40 5v4h-2v2h2v4h-2v2h2v4h-2v2h2v4h-2v2h2v5h-5v-2h-2v2h-4v-2h-2v2h-4v-2h-2v2h-4v-2h-2v2h-4v-2h-2v2H8v-2H6v2H1v-5h2v-2H1v-4h2v-2H1v-4h2v-2H1v-4h2v-2H1V8h2V6H1V1h5v2h2V1h4v2h2V1h4v2h2V1h4v2h2V1h4v2h2V1h4v2h2V1h5v5h-2v2h2zM18 21h8a4 4 0 014 4v2H14v-2a4 4 0 014-4zm4-3a4 4 0 110-8 4 4 0 010 8z',
        fill: '#D9D9D9',
        fillRule: 'nonzero',
      })
    )
  );
}
